const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].#subform[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].TextField6[0]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[7].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].#subform[7].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[7].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[7].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[7].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[7].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[7].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[0].CheckBox36[0]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[1]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[1].CheckBox36[1]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[2]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[2].CheckBox36[2]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[3]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[3].CheckBox36[3]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[4]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[4].CheckBox36[4]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[5]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[5].CheckBox36[5]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[6]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[6].CheckBox36[6]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[7]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[3].#area[7].CheckBox36[8]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[8]",
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[3].TextField6[3]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[9]",
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[3].TextField6[5]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[10]",
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[3].TextField6[6]",
            dateDbqName: "form1[0].#subform[3].Dt-of-Diag[11]",
        }    
    ]

}

export default ssn ;